import { render } from "./AiPreparation.vue?vue&type=template&id=b99e0cb4&scoped=true"
import script from "./AiPreparation.vue?vue&type=script&lang=js"
export * from "./AiPreparation.vue?vue&type=script&lang=js"

import "./AiPreparation.vue?vue&type=style&index=0&id=b99e0cb4&scoped=true&lang=scss"
import "./AiPreparation.vue?vue&type=style&index=1&id=b99e0cb4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99e0cb4"]])

export default __exports__